import { useEffect, useState } from 'react';

export const useLoaderProgress = (
  isLoading: boolean,
  onComplete: () => void
) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let intervalId: NodeJS.Timeout;
    const incrementInterval = 500;
    const incrementStep = 10;

    if (isLoading) {
      setProgress(0);
      intervalId = setInterval(() => {
        setProgress((prevProgress) =>
          Math.min(prevProgress + incrementStep, 100)
        );
      }, incrementInterval);
    } else {
      intervalId = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 100) {
            clearInterval(intervalId);
            return prevProgress;
          }
          return Math.min(prevProgress + incrementStep, 100);
        });
      }, incrementInterval);
    }

    return () => clearInterval(intervalId);
  }, [isLoading]);

  useEffect(() => {
    if (progress >= 100) onComplete();
  }, [progress, onComplete]);

  return progress;
};
